import { ApiResponse, TokenData } from "../models";
import { LeadSource } from "../models/leadSource";
import * as http from "./http";
import ApiService from "./service";

export class LeadSourceService extends ApiService {
  public async loadAllLeadSource() {
    const url = `${this.apiDomain}/api/lead-source`;

    const resposne = await http.get<ApiResponse<LeadSource[]>>(url, this.store);
    return resposne?.data?.data;
  }
  public async createLeadSource(data: LeadSource) {
    const url = `${this.apiDomain}/api/lead-source`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateLeadSource(data: LeadSource, id?: string) {
    const url = `${this.apiDomain}/api/lead-source/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteLeadSource(id?: string) {
    const url = `${this.apiDomain}/api/lead-source/${id}`;

    const response = await http.remove<ApiResponse<LeadSource>>(
      url,
      this.store
    );
    return response.data;
  }
}
